import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-20 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/b8f61369-3068-4b34-ba8e-c44fc061564d.png" 
            alt="OPTIMUM d.o.o. Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className="text-xl font-bold text-gray-900">OPTIMUM d.o.o.</span>
        </div>
        <div className="flex items-center gap-12">
          <button
            onClick={() => scrollToSection('home')}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
          >
            Products
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}
